var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"negative"},[_c('h2',{staticClass:"normal",domProps:{"innerHTML":_vm._s(_vm.$t('confirmation.negative.header'))}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('confirmation.negative.description'))}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('confirmation.negative.description2'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }